import React from 'react';
import { Link } from 'react-router-dom';
import AuthenticationWrapper from 'components/layout/AuthenticationWrapper';
import { LANDING } from 'constants/routes';
import { ButtonFilled } from 'components/ui/Button';

import {
  Title,
  Text,
  IntroHead,
  BottomWrapper,
} from './styled';

const PageNotFound = () => {

  return (
    <AuthenticationWrapper>
      <IntroHead>
        <Title>404</Title>
        <Text>Oops! Looks like you got lost</Text>
      </IntroHead>

      <BottomWrapper>
        <Link to={LANDING}>
          <ButtonFilled>Take me back</ButtonFilled>
        </Link>
      </BottomWrapper>
    </AuthenticationWrapper>
  );
};

export default PageNotFound;
